import React, { useEffect, useState } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { UpgradeDialog } from "../components/UpgradeDialog";
import { PRIVACY, TERMS } from "../content/legal";

const DOCS = {
  privacy: {
    title: "Privacy Policy",
    intro: "BidMark Quotes (“we,” “us,” or “our”) operates the website bidmarkquotes.com. This Privacy Policy explains what information we collect, how we use it, and your choices.",
    body: PRIVACY,
  },
  terms: { title: "Terms of Service", intro: "These Terms govern your use of BidMark Quotes at bidmarkquotes.com.", body: TERMS },
};

const linkify = (s, k) => {
  const parts = s.split(/(info@bidmarkquotes\.com|\(857\) 520-3500)/);
  return parts.map((p, i) =>
    p === "info@bidmarkquotes.com" ? <a key={`${k}-${i}`} href="mailto:info@bidmarkquotes.com" className="text-[#1B3A4B] underline underline-offset-2">{p}</a>
    : p === "(857) 520-3500" ? <a key={`${k}-${i}`} href="tel:+18575203500" className="text-[#1B3A4B] underline underline-offset-2">{p}</a>
    : p
  );
};

const inline = (s) => s.split(/(\*\*[^*]+\*\*)/).map((p, i) =>
  p.startsWith("**") ? <strong key={i} className="text-[#1C1915]">{p.slice(2, -2)}</strong> : <React.Fragment key={i}>{linkify(p, i)}</React.Fragment>
);

const Body = ({ text }) =>
  text.split("\n\n").map((block, i) => {
    const lines = block.split("\n");
    if (/^\*\*\d+\./.test(block)) return <h2 key={i} className="font-serif text-2xl text-[#1B3A4B] pt-4">{block.replace(/\*\*/g, "")}</h2>;
    const lead = lines[0].startsWith("- ") ? null : lines[0];
    const items = lines.filter((l) => l.startsWith("- "));
    return (
      <div key={i}>
        {lead && <p>{inline(lead)}{lines.slice(1).filter((l) => !l.startsWith("- ")).map((l, j) => <React.Fragment key={j}><br />{inline(l)}</React.Fragment>)}</p>}
        {items.length > 0 && <ul className="list-disc pl-6 space-y-1.5 mt-2">{items.map((l, j) => <li key={j}>{inline(l.slice(2))}</li>)}</ul>}
      </div>
    );
  });

export default function LegalPage({ doc }) {
  const d = DOCS[doc];
  const [upgradeOpen, setUpgradeOpen] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [doc]);
  return (
    <div className="min-h-screen flex flex-col">
      <Header onUpgrade={() => setUpgradeOpen(true)} />
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
        <article data-testid={`legal-${doc}`} className="bg-white/85 backdrop-blur-md border border-[#E2DCD2] rounded-2xl shadow-sm p-6 sm:p-10">
          <h1 className="font-serif text-4xl sm:text-5xl text-[#1B3A4B]">{d.title}</h1>
          <p className="mt-2 text-sm font-semibold text-[#A6844A]">Effective Date: October 29, 2026</p>
          <div className="mt-6 space-y-4 text-[15px] leading-relaxed text-[#3D3830]">
            <p>{d.intro}</p>
            <Body text={d.body} />
          </div>
        </article>
      </main>
      <Footer />
      <UpgradeDialog open={upgradeOpen} onOpenChange={setUpgradeOpen} />
    </div>
  );
}
